import React from "react";
import { ExternalLink, FileText } from "lucide-react";
import { useAuthBlob, Spinner } from "@/components/accounting/ui";

export const DocPreview = ({ doc }) => {
  const isPdf = doc.kind === "pdf";
  const variant = doc.has_view ? "view" : "original";
  const { src, failed } = useAuthBlob(`/admin/accounting/docs/${doc.id}/file?variant=${variant}`);
  return (
    <div className="flex flex-col h-full" data-testid="acc-doc-preview">
      <div className="flex-1 min-h-[300px] md:min-h-[460px] rounded-lg border border-line bg-elevated overflow-hidden flex items-center justify-center">
        {!src && !failed && <Spinner />}
        {failed && <p className="text-sm text-faint flex items-center gap-2"><FileText size={16} /> Vorschau nicht verfügbar</p>}
        {src && isPdf && <iframe src={src} title="PDF-Vorschau" className="w-full h-full min-h-[300px] md:min-h-[460px] bg-white" data-testid="acc-doc-preview-pdf" />}
        {src && !isPdf && <img src={src} alt="Belegvorschau" className="max-w-full max-h-[60vh] object-contain" data-testid="acc-doc-preview-img" />}
      </div>
      {src && (
        <a href={src} target="_blank" rel="noopener noreferrer" className="text-xs text-dim hover:text-ink inline-flex items-center gap-1.5 mt-2" data-testid="acc-doc-preview-open">
          <ExternalLink size={12} /> In neuem Tab öffnen
        </a>
      )}
      {doc.kind === "heic" && <p className="text-[11px] text-faint mt-1">HEIC-Original wird als JPG angezeigt; das Original bleibt erhalten.</p>}
    </div>
  );
};

export default DocPreview;
